import Signin from '@signin/signin'
import router from '@modules/router'
import BaseForm from '@modules/baseForm'
import { dispatch } from '@modules/dispatchForm'
import messenger from '@modules/messenger'
import leadTracking from '@titanio/lead-tracking'

import {
  getLoginUrl,
  getStagetId,
  isLoginWithPassword
} from './src/utils'

const classname = {
  form: '#js-presignin-form',
  socialStep: '#js-social-step'
}

class Presignin extends BaseForm {
  constructor () {
    super({ target: classname.form })
  }

  mount () {
    this.stagesListened = []
    this.api = '/account/api/pre-login/'
    this.socialStep = document.querySelector(classname.socialStep)

    router.mount()
  }

  validate () {
    this.instance.Email(this.validator)
    this.instance.VerifyEmail(this.validator)
  }

  request () {
    const body = new FormData(this.form)
    leadTracking.setAcquisition('auth-presignin')

    dispatch(this.form, body, this.api).then((data) => {
      if (!data) {
        messenger.show({ context: this.form })
        leadTracking.removeAcquisition()
        return
      }

      const { user } = data
      this.path = getLoginUrl(data)
      this.stageId = getStagetId({ path: this.path })

      if (isLoginWithPassword(data)) {
        this.getLoginPasswordStage(data)
      }

      router.changeHistory({
        path: `account/${this.path}`,
        user: user && user.name,
        stageId: this.stageId
      })
    })
  }

  getLoginPasswordStage (data) {
    this.handlerOnLoginStage = this.onLoginPasswordStage.bind(this)
    this.stage = document.querySelector(`${this.stageId}`)
    this.toggleSocialButtons(data)

    if (this.stagesListened.includes(this.stage)) return
    this.stage.addEventListener('step-on-show', this.handlerOnLoginStage, false)
    this.stagesListened = [...this.stagesListened, this.stage]
  }

  toggleSocialButtons ({ google, facebook, apple }) {
    const social = { google, facebook, apple }
    const method = Object.entries(social).find(([key, value]) => value)?.[0]
    if (method) {
      this.socialStep.setAttribute('data-method', method)
    } else {
      this.socialStep.removeAttribute('data-method')
    }
  }

  onLoginPasswordStage () {
    /**
     * create cookie with user e-mail
     * used on recovey to auto fill textfield
     */
    if (this.path === 'login') this.setUserEmailOnCookie()

    /**
     * create (sigin/signup)  instance
     */
    const signin = new Signin({
      type: this.path,
      stage: this.stage
    })

    signin.fillHiddenFieldWithEmail({
      email: this.form.elements.email.value
    })
  }

  setUserEmailOnCookie () {
    const now = new Date()
    now.setTime(now.getTime() + (2 * 60 * 1000))
    document.cookie = `fgn_user_email=${this.form.elements.email.value}${`; expires=${now.toUTCString()}`}; domain=${window.location.hostname}; path=/`
  }
}

export default Presignin
